<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="login-card">
        <div>
          <div>
            <a class="logo" routerLink="/">
              <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="looginpage" />
              <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage" />
            </a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="registrationForm">
              <h4>Sign in to account</h4>
              <p>Enter your email & password to login</p>
              <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input class="form-control" type="email" required="true" placeholder="app@yourmail.com" formControlName="email" />
              </div>
              <div class="form-group">
                <label class="col-form-label">Password</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required="" placeholder="*********" />
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Name</label>
                <input class="form-control" type="text" required="true" placeholder="Name" formControlName="name" />
              </div>

              <div class="form-group">
                <label class="col-form-label">Surname</label>
                <input class="form-control" type="text" required="true" placeholder="Surname" formControlName="surname" />
              </div>

              <div class="form-group">
                <label class="col-form-label">Phone</label>
                <input class="form-control" type="text" required="true" placeholder="380989898989" formControlName="phone" />
              </div>

              <div class="form-group mb-0">
                <a class="link">Forgot password?</a>
                <div class="text-end mt-3">
                  <button class="btn btn-primary d-block w-100" [disabled]="!registrationForm.valid" (click)="registr()" type="button"><span>Sign in</span></button>
                </div>
              </div>
              
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
